import { Reducer } from 'redux';

import { Action, ActionType } from '../actionTypes/reportVisitActionType';
import { IReportVisit as ReportVisit } from '../../models/reportVisit';

export interface IReportVisitState {
    reportVisits: ReportVisit[];
    loading: boolean;
    error: string | null,
}
const initialState = {
    reportVisits: [],
    loading: false,
    error: '',
};
export const ReportVisitReducer: Reducer<IReportVisitState, Action> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ActionType.FETCH_REPORTVISITS:
        case ActionType.EDIT_REPORTVISIT:
            return { ...state, loading: true };

        case ActionType.FETCH_REPORTVISITS_FAIL:
        case ActionType.EDIT_REPORTVISIT_FAIL:
            return { 
                ...state, 
                loading: false,
                error: action.payload
            };

        case ActionType.FETCH_REPORTVISITS_SUCCESS:
            // console.log('action.payload: ', action.payload.data)
            return {
                ...state,
                reportVisits: action.payload.data,
                loading: false
            };
        // case ActionType.EDIT_REPORTVISIT_SUCCESS:
            // return {
            //     ...state,
            //     reportVisits: action.payload.data,
            //     loading: false
            // };
        default:
            return state;
    }
};
